import styled from 'styled-components';
import { DOWN_ARROW } from '../../../Assets/images';

const MobileInputFieldStyled = styled.div`
  .input-group {
    align-items: flex-end;
  }

  img {
    opacity: 1 !important;
  }

  .form-label {
    font-size: 13px !important;
    font-weight: 600 !important;
    margin-bottom: 4px !important;
    color: ${(props) => props.theme.text.medium} !important;
  }
  .list_country_dropdown {
    height: 152px;
    overflow: auto;
  }
  .country_dropdown {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    color: ${(props) => props.theme.text.dark} !important;
    background: ${(props) => props.theme.color.white} !important;
    padding: 4px 24px 4px 0px !important;
    height: auto !important;
    border-radius: 0px !important;
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.color.border} !important;

    &.btn:disabled {
      background-color: ${(props) => props.theme.color.white} !important;
      color: ${(props) => props.theme.text.light}98 !important;
      opacity: 1;
      position: relative;
      border-radius: 0px !important;
      border: none !important;
      border-bottom: 1px solid ${(props) => props.theme.color.border} !important;
      padding-left: 8px !important;
      cursor: not-allowed !important;
    }

    &.btn {
      &::before {
        position: absolute;
        content: '';
        width: 1px;
        height: 24px;
        background-color: ${(props) => props.theme.color.border};
        right: -10px;
        top: 6px;
      }
    }

    &::before {
      top: 6px !important;
      right: -10px !important;
    }

    &::after {
      width: 11px;
      height: 8px;
      content: '';
      background: url(${DOWN_ARROW.src}) no-repeat 50% 50%;
      margin: 0;
      border: 0;
      position: absolute;
      top: 50%;
      right: 2px;
      transform: translateY(-50%);
      display: flex;
    }

    .dropdown-item {
      display: flex;
      align-items: center;
    }
  }

  .inputField {
    min-height: 44px !important;
    height: 54px !important;
    border-radius: 0px !important;
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.color.border} !important;
    padding: 18px 8px 0px 20px !important;

    & ~ label {
      padding-left: 20px !important;
    }

    &:disabled ~ label {
      opacity: 0.5;
    }

    &:not(:focus) {
      &:placeholder-shown {
        & ~ label {
          display: flex;
          flex-direction: column;
          justify-content: end;
          padding-bottom: 0px;

          .form-label {
            font-size: 16px !important;
            font-weight: 400 !important;
          }
        }
      }
    }

    &:not(:placeholder-shown) {
      & ~ label {
        transform: scale(0.85) translateY(-0.8rem) translateX(-8.5rem) !important;

        .form-label {
          font-size: 13px !important;
          font-weight: 600 !important;
        }
      }
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0;
      border-color: #1976d2 !important;

      & ~ label {
        transform: scale(0.85) translateY(-0.8rem) translateX(-8.5rem) !important;

        .form-label {
          font-size: 13px !important;
          font-weight: 600 !important;
        }
      }
    }

    &.form-control {
      &:disabled {
        background-color: ${(props) => props.theme.color.white} !important;
        color: ${(props) => props.theme.text.medium} !important;
        opacity: 0.5;
        cursor: not-allowed;

        & ~ label::after {
          background-color: white;
        }
      }
    }

    &.form-control-plaintext {
      height: auto;
      color: ${(props) => props.theme.text.dark};
      font-weight: 600;
      padding: 0;
      border: 0;

      &::placeholder {
        font-size: 0;
      }
    }
    &:focus {
      outline: none;
      box-shadow: 0 0 0;
    }

    &.is-invalid {
      background-image: none !important;
      border-color: ${(props) => props.theme.verification.red.main} !important;
    }
  }

  .flag_icon {
    margin-right: 10px;
    padding-top: 4px;
  }

  .invalid-feedback {
    font-weight: 600;
    color: ${(props) => props.theme.verification.red.main};
    position: absolute;
    top: 50px;
    right: 96px;
    font-size: 15px;
  }
`;

export default MobileInputFieldStyled;